{
  "page_count": "iš {n, plural, one{# psl.} other{# psl.}}"
}
